import { useAuthTokens, UserRole } from "modules/auth";
import { Navigate } from "react-router-dom";

import { AuthLayoutProps } from "./AuthRoute.types";

const AuthLayout = ({ children }: AuthLayoutProps) => {
  const { accessToken, role } = useAuthTokens();

  if (!accessToken) return children;

  if (role === UserRole.DeliveryCompany || role === UserRole.CompanyManager) {
    return <Navigate to="/company" replace />;
  }

  return <Navigate to="/" replace />;
};

export default AuthLayout;
